import type { NavigateFunction } from 'react-router-dom'
import { recordSession, type SignInMethod } from '@/api/users'

/** Called right after Clerk's setActive() completes a sign-in or sign-up. Records the session
 *  (audit trail) — by the time setActive() has run, any second factor is already satisfied,
 *  since Clerk won't issue a session for a user with 2FA enabled until it's done. */
export async function completeAuthAndRedirect(
  navigate: NavigateFunction,
  redirectTo: string,
  method: SignInMethod
) {
  try {
    await recordSession(method)
  } catch {
    // best-effort — don't block navigation if the audit call fails
  }
  navigate(redirectTo, { replace: true })
}
